// All app configs: app name, email, phone, copyright...
const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const browserHostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalhostRuntime =
  browserHostname === 'localhost' || browserHostname === '127.0.0.1' || browserHostname === '::1';
const defaultDomainUrl = browserOrigin || '';
const defaultBaseUrl = browserOrigin ? `${browserOrigin}/` : '/';
const defaultApiUrl = browserOrigin ? `${browserOrigin}/api/v1/admin` : '/api/v1/admin';

const normalizeEnvValue = (value) => (typeof value === 'string' ? value.trim() : '');
const shouldUseEnvOnLocalhost = normalizeEnvValue(process.env.REACT_APP_USE_ENV_ON_LOCALHOST) === '1';
const ensureTrailingSlash = (value) => (value.endsWith('/') ? value : `${value}/`);
const resolveDomainUrl = (envValue, fallbackValue) => {
  const normalized = normalizeEnvValue(envValue);

  if (isLocalhostRuntime && !shouldUseEnvOnLocalhost) {
    return browserOrigin || fallbackValue;
  }

  if (!normalized || normalized === '/') {
    return browserOrigin || fallbackValue;
  }

  return normalized.replace(/\/$/, '');
};
const resolveBaseUrl = (envValue, fallbackValue) => {
  const normalized = normalizeEnvValue(envValue);

  if (isLocalhostRuntime && !shouldUseEnvOnLocalhost) {
    return ensureTrailingSlash(browserOrigin || fallbackValue);
  }

  if (!normalized) {
    return fallbackValue;
  }

  if (normalized === '/') {
    return '/';
  }

  return ensureTrailingSlash(normalized);
};
const resolveApiUrl = (envValue, fallbackValue) => {
  const normalized = normalizeEnvValue(envValue);

  if (isLocalhostRuntime && !shouldUseEnvOnLocalhost) {
    return `${browserOrigin}/api/v1/admin`;
  }

  return normalized || fallbackValue;
};

const AppConfigs = {
  env: {
    // dev
    domainUrl: resolveDomainUrl(process.env.REACT_APP_DOMAIN_URL, defaultDomainUrl),
    baseUrl: resolveBaseUrl(process.env.REACT_APP_BASE_URL, defaultBaseUrl),
    apiUrl: resolveApiUrl(process.env.REACT_APP_API_URL, defaultApiUrl),
    hideBike: 1,
    // baseUrl: 'http://localhost:3004/',
    // apiUrl: 'http://localhost:3004/api/v1/admin',
    ekycAppstore: 'https://apps.apple.com/vn/app/mdc-ekyc/id1478097342',
    ekycPlayStore: 'https://play.google.com/store/apps/details?id=com.ekyc.app',
    // prod
    // domainUrl: 'https://cms.evglobal.vn',
    // baseUrl: 'https://api.evglobal.vn/',
    // apiUrl: 'https://api.evglobal.vn/api/v1/admin',
    // hideBike: 1,
  },

  // thoi gian dinh ky lay data realtime dashboard (ms)
  timeIntervalGetDashboardDataRealtime: 5000,
  timeIntervalGetChargeTransactionDetail: 5000,
  timeIntervalGetChargePaymentStatus: 5000,
  timeIntervalGetSuperDashboardData: 5000,

  defaultPageLimit: 10,

  packageName: 'com.evg.cms',
  appName: 'EVG Admin',
  version: '1.0',
  build: 1,

  saleCommission: [],
  energyCommissionMode: 'FIXED_PER_KWH',
  energyCommissionValue: 0,
  energyCommissionDuration: 0,
  serviceCommission: 0,

  devBuildDate: '02/07/2026',
  productBuildDate: '18/06/2026',

  // bing map config
  bingMapOption: {
    liteMode: true,
    showLocateMeButton: false,
    showMapTypeSelector: false,
    showScalebar: false,
    showTermsLink: false,
    showZoomButtons: false,
    showDashboard: false,
    showBreadcrumb: false,
    enableClickableLogo: false,
    customMapStyle: {
      elements: {
        water: { fillColor: '#a1e0ff' },
        waterPoint: { iconColor: '#a1e0ff' },
        // transportation: { strokeColor: '#aa6de0' },
        // road: { fillColor: '#b892db' },
        // railway: { strokeColor: '#a495b2' },
        // structure: { fillColor: '#ffffff' },
        // runway: { fillColor: '#ff7fed' },
        // area: { fillColor: '#f39ebd' },
        // political: { borderStrokeColor: '#fe6850', borderOutlineColor: '#55ffff' },
        // point: { iconColor: '#ffffff', fillColor: '#FF6FA0', strokeColor: '#DB4680' },
        // transit: { fillColor: '#AA6DE0' },
      },
      version: '1.0',
    },
  },

  // regex
  regex: {
    phone: /^(0[0-9]{9,10}|\+84[0-9]{9})$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    plate: /^[0-9]{2}[A-Z]-[0-9]{4,5}$/,
    coordinate:
      /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?),( |-)?-?((1[0-7][0-9]|[1-9]?[0-9])(\.\d+)?|180(\.0+)?)$/,
    idCardNumber: /^[0-9]{12}$/,
    passportNumber: /^[A-Z][0-9]{7}$/,
    taxCode10: /^[0-9]{10}([0-9]{2})?$/,
    taxCode13: /^[0-9]{10}-[0-9]{3}$/,
    url: /^(http|https):\/\/[^ "]+$/,
    vehiclePlate: /^[0-9A-Z.Đ-]{1,10}$/,
    latitude: /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)(?=\s*,?\s*)$/,
    longitude: /^-?((1[0-7][0-9]|[1-9]?[0-9])(\.\d+)?|180(\.0+)?)(?=\s*,?\s*)$/,
    vinNumber: /^[0-9A-HJ-NPR-Z-]{1,17}$/,
  },
};

export default AppConfigs;
